import { Box } from "grommet";
import React from "react";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import LinkAnchor from "../components/LinkAnchor";
import { AliasViewModel } from "./AliasStore";

export const AliasRow = ({ alias, reverse, children }: { alias: AliasViewModel; reverse?: boolean; children?: React.ReactElement }) => {
    let BoxProps = {};

    const navigate = useNavigate();

    if (!children) {
        BoxProps = {
            hoverIndicator: "background-back",
            onClick: () => {
                navigate(`/aliases/${alias.id}`);
            },
        };
    }

    return !reverse ? (
        <Box background={"background"} pad="medium" direction="row" gap="small" {...BoxProps}>
            <Box justify="center">
                <Avatar src={alias.photoUri} name={alias.name} size="35px" alt="" />
            </Box>
            <Box justify="between" direction="row" width="100%">
                <Box justify="center">
                    <LinkAnchor path={`/aliases/${alias.id}`} label={AliasViewModel.displayName(alias)}></LinkAnchor>
                </Box>
                <Box justify="center">{children}</Box>
            </Box>
        </Box>
    ) : (
        <Box background={"background"} pad="medium" direction="row" gap="small" {...BoxProps}>
            <Box justify="between" direction="row" width="100%">
                <Box justify="center">{children}</Box>
                <Box justify="center">
                    <LinkAnchor path={`/aliases/${alias.id}`} label={AliasViewModel.displayName(alias)}></LinkAnchor>
                </Box>
            </Box>
            <Box justify="center">
                <Avatar src={alias.photoUri} name={alias.name} size="35px" alt="" />
            </Box>
        </Box>
    );
};
